<template>
  <v-card flat height="calc(100vh - 106px)" class="overflow-y">
    <v-container>
      <v-row>
        <v-col align="center"><v-img src="@/assets/shopify_logo_black.png" width="200"/></v-col>
      </v-row>

      <template v-if="!shopify">
        <v-row class="mt-6">
          <v-col cols="12" sm="10" offset-sm="1">
            To connect to Shopify, the following steps must be done:
            <ol>
              <li>The name of your shop on Shopify must be entered.</li>
              <li>We must create a "Custom" Shopify application for your shop.
                When this is done, we will send you an email with a link for you to click that
                will initiate a process for you to establish the connection between PŪRTRAK and your shop.
                (Please allow up to 24 hours for us to send you this link.)</li>
              <li>After the connection is established, you will be able to map your products between PŪRTRAK and Shopify,
                update your inventory in Shopify, and tell PŪRTRAK how to process your Shopify orders.</li>
            </ol>
          </v-col>
        </v-row>
        <v-row class="mt-4">
          <v-col offset-sm="1">
            Please enter the name of your shop on Shopify.
          </v-col>
        </v-row>
        <v-row align="center" class="mt-4">
          <v-col cols="12" sm="5" offset-sm="1">
            <v-text-field prefix="https://" suffix=".myshopify.com" label="Store name" outlined v-model="shop" :error="!shop" hide-details/>
          </v-col>
          <v-col><v-btn color="primary" @click="requestConnection" :disabled="!shop" :loading="loading">Request Connect Link</v-btn></v-col>
        </v-row>
      </template>

      <template v-else-if="!shopify.connection">
        <v-row class="mt-4">
          <v-col align="center" offset-sm="1" sm="10">
            You have requested a Custom Shopify application be set up for your Shopify shop "{{shopify.shop}}"
            You will receive a link from us (within 24 hours) that you must click in order to
            complete the process of establishing a connection between PŪRTRAK and your Shopify shop.
          </v-col>
        </v-row>
      </template>

      <template v-else>
        <v-row>
          <v-col align="center">
            PŪRTRAK is connected to Shopify shop <strong>{{shopify.shop}}</strong>.
          </v-col>
        </v-row>
        <v-row class="mt-10">
          <v-col align="center"><v-btn color="primary" outlined @click="confirmDisconnect=true">Disconnect</v-btn></v-col>
        </v-row>
      </template>
    </v-container>

    <v-dialog v-model="confirmDisconnect" persistent max-width="350">
      <v-card>
        <v-card-title>Disconnect</v-card-title>
        <v-divider/>
        <v-card-text class="pt-4">
          Are you sure you want to disconnect from Shopify?
        </v-card-text>
        <v-divider/>
        <v-card-actions class="pr-6">
          <v-spacer></v-spacer>
          <v-btn color="primary" plain @click="disconnect" :loading="loading">Disconnect</v-btn>
          <v-btn color="primary" @click="confirmDisconnect=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
export default {
  name: 'AppsShopifyConnection',
  props: {
    shopify: {type:Object, required:false}
  },
  data() {
    return {
      shop: '',
      loading: false,
      confirmDisconnect: false,
    }
  },
  methods: {
    async requestConnection() {
      this.loading = true;
      const results = await this.$apiCall(`mutation AppsShopifyConnection($shop:String!) {
                                                shopifyRequestConnection(shop:$shop) {
                                                  connection,shop
                                                }
                                              }`,
                                          {shop:this.shop}, false, 'shopify');
      if (!results.error)
        this.$emit('refresh', results.data.shopifyRequestConnection)
      this.loading = false;
    },
    async disconnect() {
      this.loading = true;
      const results = await this.$apiCall(`mutation AppsShopifyConnection {
                                                disconnect
                                              }`,
                                          {}, false, 'shopify');
      this.loading = false;
      if (!results.error) {
        this.$emit('disconnect');
        this.confirmDisconnect = false;
      }
    }
  }
}
</script>
